import React, { useState, useEffect } from "react";
import "./UserQuizSummary.css";

function UserPersonalitySummary() {
  const [latestScore, setLatestScore] = useState(null);
  const [maxScore, setMaxScore] = useState(null);
  const [loading, setLoading] = useState(true);

  // definitions for personality traits
  const traitDefinitions = {
    Extraversion: "Sociability, assertiveness, and enthusiasm.",
    Agreeableness: "Compassion, trust, and cooperation with others.",
    Conscientiousness: "Organization, dependability, and discipline.",
    "Emotional Stability":
      "Emotional stability vs. tendency toward anxiety and moodiness.",
    "Intellect/Imagination":
      "Creativity, curiosity, and openness to new experiences.",
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/score/personality`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.score && data.maxScore) {
          setLatestScore(data.score);
          setMaxScore(data.maxScore);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching personality score:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading personality results...</div>;
  }

  if (!latestScore) {
    return (
      <div className="no-scores">
        <h1>
          <b>No Personality Quizzes Completed Yet</b>
        </h1>
        <p>Take the personality quiz to learn about your traits.</p>
      </div>
    );
  }

  return (
    <div className="results-dash-summary">
      <b>Your Most Recent Personality Results</b>
      <ul>
        {Object.entries(latestScore).map(([trait, value]) => {
          const max = maxScore?.[trait] || 0;
          const percentage = max > 0 ? ((value / max) * 100).toFixed(1) : 0;
          return (
            <li key={trait}>
              <b>{trait}</b> –{" "}
              {traitDefinitions[trait] || "No definition available."}
              <br />
              Score: {value} / {max} ({percentage}%)
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default UserPersonalitySummary;
